/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbPostRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getCmdbConfigStatusTypeUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbConfigReferenceTypeUrl.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { StatusTypeResponse, ActionApi } from './ActionApi.types.tsx';

type RequestBodyType = {
	name: string;
	displayName?: string;
	description: string;
	category: string;
};

export const createStatusType =
	(data: RequestBodyType): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		setState({
			...state,
			statusTypes: { ...state.statusTypes, createLoading: true },
		});

		try {
			const response: StatusTypeResponse = await performCmdbPostRequest(
				getCmdbConfigStatusTypeUrl(workspaceId),
				{ body: JSON.stringify(data) },
			);

			setState({
				...state,
				statusTypes: {
					...state.statusTypes,
					createLoading: false,
					data: [...(state.statusTypes.data ?? []), response],
				},
			});

			fireTrackAnalytics(
				createAnalyticsEvent({
					source: 'insightGlobalConfigStatuses',
					action: 'created',
					actionSubject: 'insightGlobalConfigStatuses',
				}),
				'insightGlobalConfigStatuses created',
			);
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...state,
				statusTypes: { ...state.statusTypes, createLoading: false, createError: error },
			});

			fireCmdbErrorAnalytics({
				meta: {
					id: 'createStatusType',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'astral',
				},
				error,
			});

			throw error;
		}
	};
